module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1700.2ef30410.svg";